import { useEffect, useState } from 'react';
import api from '../../services/api';
import Button from '../../components/Button';

export default function AppraisalSettings() {
  const [enableSelfAppraisal, setEnableSelfAppraisal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    api.get('/pas/settings').then((res) => setEnableSelfAppraisal(!!res.data.enableSelfAppraisal));
  }, []);

  const save = async () => {
    setLoading(true);
    try {
      await api.put('/pas/settings', { enableSelfAppraisal });
      setMessage('Settings saved');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 max-w-xl">
      <h1 className="text-2xl font-bold mb-6">Appraisal Settings</h1>
      {message && <div className="mb-4 text-sm text-green-700 bg-green-50 border border-green-200 rounded px-4 py-2">{message}</div>}
      <div className="bg-white rounded-lg shadow p-6 space-y-4">
        <label className="flex items-start gap-3">
          <input
            type="checkbox"
            className="mt-1"
            checked={enableSelfAppraisal}
            onChange={(e) => setEnableSelfAppraisal(e.target.checked)}
          />
          <span>
            <span className="font-medium block">Enable Employee Self Appraisal</span>
            <span className="text-sm text-gray-500">
              When ON, the employee appraises themselves first, then the approver chain appraises. When OFF, the approver appraises directly.
            </span>
          </span>
        </label>
        <Button onClick={save} loading={loading}>Save</Button>
      </div>
    </div>
  );
}
